import styled from "styled-components";

const LiveSessionCard = () => {
  return (
    <div>
      <Card>
        <h2 style={{ fontWeight: 600 }}>Live Session 42-Life Style</h2>
        <iframe
          src="https://www.youtube.com/embed/efGa8QD8pU4"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="video"
          height="400"
        />
        <LikesRow>
          <div>
            <img src="/img/Mask Group 15.png" alt="" />
            <img src="/img/Mask Group 16.png" alt="" />
            <img src="/img/patient1@2x.png" alt="" />
          </div>
          <h4>Liked by 3 people</h4>
          <img src="/img/like.svg" alt="" />
        </LikesRow>
        <CommentRow>
          <div>
            <img src="/img/Mask Group 15.png" alt="" />
            <span style={{ flexGrow: 1 }}>
              <h5>Juan Joe</h5>
              <div
                style={{
                  width: "20%",
                  height: "5px",
                  background: "#05C4E2",
                  borderRadius: "36px",
                  opacity: 1,
                  margin: "1rem 0",
                }}
              />
            </span>
          </div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores
            molestias molestiae eaque sapiente pariatur veniam consectetur
            facilis, itaque quas beatae ea in rerum repudiandae earum officia
            corrupti culpa minus necessitatibus!
          </p>
        </CommentRow>
        <hr />
        <div
          style={{
            paddingRight: "1rem",
            backgroundColor: "#CCD0D2",
            borderRadius: "20px",
            display: "grid",
            gridTemplateColumns: "auto 40px",
          }}
        >
          <input
            placeholder="Write a comment"
            style={{
              margin: "0 2rem",
              backgroundColor: "#CCD0D2",
            }}
          />
          <button
            id="button-addon2"
            style={{
              backgroundColor: "#CCD0D2",
              border: "none",
              borderTopRightRadius: "20px",
              borderBottomRightRadius: "20px",
            }}
          >
            <img src="/img/direction-top-right.svg" alt="" />
          </button>
        </div>
      </Card>
      <Card>
        <h2 style={{ fontWeight: 600 }}>Healthcare in 2030</h2>
        <iframe
          title="video"
          height="400"
          src="https://www.youtube.com/embed/9zlUNw3y5rg"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <LikesRow>
          <div>
            <img src="/img/patient1@2x.png" alt="" />
            <img src="/img/Mask Group 15.png" alt="" />
            <img src="/img/Mask Group 16.png" alt="" />
          </div>
          <h4>Liked by 31 people</h4>
          <img src="/img/like.svg" alt="" />
        </LikesRow>
        <CommentRow>
          <div>
            <img src="/img/patient1@2x.png" alt="" />
            <span style={{ flexGrow: 1 }}>
              <h5>Joe</h5>
              <div
                style={{
                  width: "20%",
                  height: "5px",
                  background: "#05C4E2",
                  borderRadius: "36px",
                  opacity: 1,
                  margin: "1rem 0",
                }}
              />
            </span>
          </div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores
            molestias molestiae eaque sapiente pariatur veniam consectetur
            facilis, itaque quas beatae ea in rerum repudiandae earum officia
            corrupti culpa minus necessitatibus!
          </p>
        </CommentRow>
        <hr />
        <div
          style={{
            paddingRight: "1rem",
            backgroundColor: "#CCD0D2",
            borderRadius: "20px",
            display: "grid",
            gridTemplateColumns: "auto 40px",
          }}
        >
          <input
            placeholder="Write a comment"
            style={{
              margin: "0 2rem",
              backgroundColor: "#CCD0D2",
            }}
          />
          <button
            id="button-addon2"
            style={{
              backgroundColor: "#CCD0D2",
              border: "none",
              borderTopRightRadius: "20px",
              borderBottomRightRadius: "20px",
            }}
          >
            <img src="/img/direction-top-right.svg" alt="" />
          </button>
        </div>
      </Card>
    </div>
  );
};

const CommentRow = styled.div`
  margin-block: 2%;
  & > div {
    display: flex;
    & span {
      margin-left: 2%;
    }
  }
  & > div > img {
    border-radius: 50%;
    height: 3rem;
    width: 3rem;
  }
  & > p {
    margin: 0 5.5%;
    color: #707070;
  }
`;

const LikesRow = styled.div`
  display: flex;
  margin-block: 2%;
  align-items: center;

  & > img {
    margin-left: auto;
  }

  & > h4 {
    font-weight: 600;
  }

  & > div > img {
    border-radius: 50%;
    height: 3rem;
    width: 3rem;
  }
  & > div > img:not(:first-child) {
    margin-left: -10%;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin-block: 4%;
  padding: 2%;
  box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -webkit-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -moz-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  background-color: white;
  width: 50%;
  float: left;
`;

export default LiveSessionCard;
